import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * BackToTop — floating pill button that appears after scrolling past 600px.
 * Smooth scrolls to top when clicked.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollTop}
      aria-label="Back to top"
      data-testid="back-to-top"
      className={`fixed bottom-6 left-6 z-50 inline-flex items-center gap-2 bg-[#0A192F] text-white hover:bg-[#F68712] border border-[#F68712] px-4 py-3 font-mono text-[11px] tracking-widest font-bold transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp size={14} strokeWidth={2.5} />
      TOP
    </button>
  );
}
